import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useHistoricsStore = create()(
    persist(
        (set) => ({
            // Pos Terminals Historics
            refetchPosTerminalsHistorics: false,
            storeRefetchPosTerminalsHistorics: (refetchPosTerminalsHistorics) => set(() => ({ refetchPosTerminalsHistorics: refetchPosTerminalsHistorics })),
            queryPosTerminalsHistorics: getInitialQuery(),
            storeQueryPosTerminalsHistorics: (queryPosTerminalsHistorics) => set(() => ({ queryPosTerminalsHistorics: queryPosTerminalsHistorics })),

            // Sim Cards Historics
            refetchSimCardsHistorics: false,
            storeRefetchSimCardsHistorics: (refetchSimCardsHistorics) => set(() => ({ refetchSimCardsHistorics: refetchSimCardsHistorics })),
            querySimCardsHistorics: getInitialQuery(),
            storeQuerySimCardsHistorics: (querySimCardsHistorics) => set(() => ({ querySimCardsHistorics: querySimCardsHistorics })),

            // Users Historics
            refetchUsersHistorics: false,
            storeRefetchUsersHistorics: (refetchUsersHistorics) => set(() => ({ refetchUsersHistorics: refetchUsersHistorics })),
            queryUsersHistorics: getInitialQuery(),
            storeQueryUsersHistorics: (queryUsersHistorics) => set(() => ({ queryUsersHistorics: queryUsersHistorics }))
        }),
        {
            name: 'historics-storage'
        }
    )
);

export default useHistoricsStore;